import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { GenericLayer } from "src/types/index";
import { layerName } from "src/utils/overlayer.utils";

interface Props<T> {
  layers: T[];
  onLayerChange: (layer: T) => void;
}

export function LayerGroupCheckbox<T extends GenericLayer>(props: Props<T>) {
  const { layers } = props;
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <Styles>
        {layers.map((layer: T) => (
          <FormControlLabel
            key={layer.key}
            className="layer-item"
            control={
              <Checkbox
                color="primary"
                checked={layer.isActive}
                size="small"
                onChange={() =>
                  props.onLayerChange({
                    ...layer,
                    isActive: !layer.isActive,
                  })
                }
              />
            }
            label={<div className="overflow-box">{layerName(layer, t)}</div>}
          />
        ))}
      </Styles>
    );
  }
}

const Styles = styled.div`
  display: flex;
  flex-direction: column;

  .layer-item {
    display: flex;
    flex-direction: row;
    height: 50px;
    width: 100%;
    padding: ${({ theme }) => theme.spacing(0, 2)};
    align-items: center;
    user-select: none;

    .MuiFormLabel-root,
    .MuiFormControlLabel-label {
      white-space: nowrap;
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
    }
  }

  --overflow-box-width: calc(var(--layer-manager-width) - 70px);

  .overflow-box {
    width: var(--overflow-box-width);
    height: 30px;
    overflow: hidden;
    line-height: 30px;
    padding: 0px;
    position: relative;
    box-sizing: border-box;
  }

  .overflow-box span {
    position: absolute;
    white-space: nowrap;
    transform: translateX(0);
    transition: 1s;
    min-width: 100%;
  }
  .overflow-box:hover span {
    transform: translateX(calc(var(--overflow-box-width) - 100%));
  }
`;
